import { useQueryClient } from '@tanstack/react-query';

import { jobArchitectureKeys } from '../../job-architecture-v2/api/query-keys';
import { companySettingsKeys } from './query-keys';

type UseCompanySettingsInvalidatorReturn = {
    readonly invalidateAll: () => Promise<void>;
    readonly invalidateCompanyProfile: () => Promise<void>;
    readonly invalidateCompanySettings: () => Promise<void>;
    readonly invalidateJobArchitectures: () => Promise<void>;
    readonly invalidateMetadata: (jobArchitectureId: string) => Promise<void>;
};

export const useCompanySettingsInvalidator = (): UseCompanySettingsInvalidatorReturn => {
    const queryClient = useQueryClient();

    return {
        invalidateAll: async () => {
            await queryClient.invalidateQueries({
                queryKey: companySettingsKeys.all,
            });
        },
        invalidateCompanyProfile: async () => {
            await queryClient.invalidateQueries({
                queryKey: companySettingsKeys.companyProfile(),
            });
        },
        invalidateCompanySettings: async () => {
            await queryClient.invalidateQueries({
                queryKey: companySettingsKeys.companySettings(),
            });
        },
        invalidateJobArchitectures: async () => {
            await queryClient.invalidateQueries({
                queryKey: companySettingsKeys.jobArchitectures(),
            });

            await queryClient.invalidateQueries({
                queryKey: jobArchitectureKeys.architectures(),
            });
        },
        invalidateMetadata: async (jobArchitectureId: string) => {
            await queryClient.invalidateQueries({
                queryKey: companySettingsKeys.metadata(jobArchitectureId),
            });
        },
    };
};
